export const InsuranceInformationFieldNames = {
  InsuranceCompany: 'insuranceCompany',
  InsuranceAddressNumber: 'insuranceAddressNumber',
  InsuranceEffectiveDate: 'insuranceEffectiveDate',
  InsuranceExpirationDate: 'insuranceExperienceDate',
  InsurancePolicyNumber: 'insurancePolicyNumber',
  InsuranceCoverageAmount: 'insuranceCoverageAmount',
  InsuranceAgentName: 'insuranceAgentAmount',
  InsurancePhoneNumber: 'insurancePhoneNumber',
  InsuranceIsOnFileWithState: 'insuranceIsOnFileWithState',
} as const;

export type InsuranceInformationFields = {
  [InsuranceInformationFieldNames.InsuranceCompany]?: string;
  [InsuranceInformationFieldNames.InsuranceAddressNumber]?: string;
  [InsuranceInformationFieldNames.InsuranceEffectiveDate]?: string;
  [InsuranceInformationFieldNames.InsuranceExpirationDate]?: string;
  [InsuranceInformationFieldNames.InsurancePolicyNumber]?: string;
  [InsuranceInformationFieldNames.InsuranceCoverageAmount]?: number;
  [InsuranceInformationFieldNames.InsuranceAgentName]?: string;
  [InsuranceInformationFieldNames.InsurancePhoneNumber]?: string;
  [InsuranceInformationFieldNames.InsuranceIsOnFileWithState]?: boolean;
};

export const InsuranceFields: string[] = Object.values(
  InsuranceInformationFieldNames,
);
